import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {APPCONFIG} from '../../config';

@Component({
  selector: 'my-page-401',
  styles: [],
  templateUrl: './401.component.html',
  standalone: false,
})
export class Page401Component implements OnInit {
  constructor(private titleService: Title) {}

  ngOnInit(): void {
    this.titleService.setTitle('Error 401 | ' + APPCONFIG.pageTitle);
  }
}
